export enum NodeType {
  // ─── Core flow ───────────────────────────────────────────────────────────────
  Start = 'start',
  End = 'end',

  // ─── Wait / timing ───────────────────────────────────────────────────────────
  WaitDays = 'waitDays',
  WaitDayOfWeek = 'waitDayOfWeek',
  WaitDayOfMonth = 'waitDayOfMonth',
  WaitDaysForDueDate = 'waitDaysForDueDate',

  // ─── Messaging ───────────────────────────────────────────────────────────────
  SendSMS = 'sendSMS',
  SendEmail = 'sendEmail',
  SendCertifiedSMS = 'sendCertifiedSMS',
  SendCertifiedEmail = 'sendCertifiedEmail',

  // ─── Conditionals ────────────────────────────────────────────────────────────
  /**
   * @bug H-02: Conditional and PaylinkNotificationStatus share the same string value
   * ('paylinkNotificationStatus'). This causes NodeFactory.mapStringToNodeType to
   * collapse two distinct backend concepts into one enum member. Do NOT fix the
   * Conditional value until backend confirms whether 'conditional' is a valid
   * node type string or an alias for 'paylinkNotificationStatus'.
   */
  PaylinkNotificationStatus = 'paylinkNotificationStatus',
  Conditional = 'paylinkNotificationStatus', // TODO(H-02): fix value — should be 'conditional'
  ConditionalSegments = 'customerCaseSegments',
  Experiment = 'experiment',
  Multi = 'multiconditional',

  // ─── Business actions (NOT_IMPLEMENTED — no confirmed backend execution) ─────
  /** @not-implemented No backend executor confirmed for this node type */
  AssignCampaign = 'assignCampaign',
  /** @not-implemented No backend executor confirmed for this node type */
  OfferPartialPayment = 'offerPartialPayment',
  /** @not-implemented No backend executor confirmed for this node type */
  OfferPaymentAgreement = 'offerPaymentAgreement',
  /** @not-implemented No backend executor confirmed for this node type */
  MakeOutBoundCall = 'makeOutboundCall',
  /** @not-implemented No backend executor confirmed for this node type */
  CreateLegalClaim = 'createLegalClaim',
  /** @not-implemented No backend executor confirmed for this node type */
  CreateMasc = 'createMasc',
}
